//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ButtonDropdown',
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: ''
    },
    mainButtonClass: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: 'down',
      validator: (value) => ['up', 'down'].includes(value)
    }
  },
  computed: {
    dropdownPosition() {
      if (this.direction === 'up') {
        return 'is-top-left'
      }
      return 'is-bottom-left'
    }
  },
  methods: {
    getMenuIcon(active) {
      const collapsedIcon = this.direction === 'up' ? 'angle-down' : 'angle-up'
      const expandedIcon = this.direction === 'up' ? 'angle-up' : 'angle-down'
      return active ? collapsedIcon : expandedIcon
    }
  }
}
